export default "__VITE_ASSET__cade79a6__"